import { definitions } from "@/services/metruyenvl";
import { Avatar } from "antd";
import { FaUserEdit } from "react-icons/fa";
import { HeadModule, NormalStyles, NormalTextUppercase } from "@/layouts/styles/ssr.style";
import Image from "next/image";
import React from "react";
import { formatDistanceToNow } from "date-fns";
import { formatValueReadings } from "@/utils/formatted";
import { vi } from "date-fns/locale";

function AuthorCover({ stat, author }: { stat?: definitions["do.StatsDO"]; author?: definitions["models.AuthorMD"] }) {
    const date = new Date((author?.created_time ?? 1707211066) * 1000);
    const distance = formatDistanceToNow(date, {
        locale: vi,
        addSuffix: true,
    });
    return (
        <div>
            <div className="flex gap-x-3">
                <Avatar size={80} src={<Image unoptimized={true} alt={author?.name ?? ""} src={author?.avatar ?? "/avatar.gif"} height={120} width={120} />} />
                <div>
                    <HeadModule styles={{ marginBottom: "4px" }}>{author?.name}</HeadModule>
                    <div className="flex items-center gap-x-2">
                        <FaUserEdit color={"#948f8c"} />
                        <NormalStyles>{distance}</NormalStyles>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Truyện</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.books_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Chương</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.chapters_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Đăng</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.published_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Đề cử</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.suggests_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Bình luận</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.comments_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Lượt thích</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.reacts_count ?? 0)}</div>
            </div>
            <div className="grid grid-cols-2 gap-x-3 pt-4 items-center mt-5 mb-4 border-solid border-t-slate-100 border-t-2">
                <NormalTextUppercase>Đánh dấu</NormalTextUppercase>
                <div className="text-base font-semibold">{formatValueReadings(stat?.bookmarks_count ?? 0)}</div>
            </div>
        </div>
    );
}

export default AuthorCover;
